import { HttpClient } from '@/data/protocols/http'
import { RemoteAccountEnrollmentDetail } from '@/data/usecases/account/remote-account-enrollment'
import { RemoteAccountEnrollments } from '@/data/usecases/account/remote-account-enrollments'
import { GenericResponse } from '@/infra/http'
import { makeApiUrl, makeHttpAuthClient } from '@/main/factories/http'
import { QueryClient } from '@tanstack/react-query'

export const makeRemoteAccountEnrollmentDetail = (
  queryClient: QueryClient
): RemoteAccountEnrollmentDetail => {
  return new RemoteAccountEnrollmentDetail(
    queryClient,
    makeApiUrl('/enrollment/v2/enrollments'),
    makeHttpAuthClient() as HttpClient<GenericResponse<RemoteAccountEnrollmentDetail.Model>>
  )
}

export const makeRemoteAccountEnrollments = (
  queryClient: QueryClient
): RemoteAccountEnrollments => {
  return new RemoteAccountEnrollments(
    queryClient,
    makeApiUrl('/enrollment/v2/enrollments'),
    makeHttpAuthClient() as HttpClient<GenericResponse<RemoteAccountEnrollments.Model>>
  )
}
